import React from 'react';
import PropTypes from 'prop-types';
import withToolboxTourTooltip from 'SelfServeTooltipTour/withToolboxTourTooltip';

export default class SimpleTooltip extends React.PureComponent {
  render() {
    return (
      <React.Fragment>
        <div className="popover-text">{this.props.tooltipText}
          { this.props.tooltipAdditionalText &&
            <div className="popover-additional-text">{this.props.tooltipAdditionalText}</div>
          }
        </div>
      </React.Fragment>
    );
  }
}

SimpleTooltip.defaultProps = {
  tooltipAdditionalText: null,
};

SimpleTooltip.propTypes = {
  tooltipText: PropTypes.string.isRequired,
  tooltipAdditionalText: PropTypes.string,
};

const SimpleToolboxTooltip = withToolboxTourTooltip(SimpleTooltip);
export { SimpleToolboxTooltip };



// WEBPACK FOOTER //
// ./src-react/SelfServeTooltipTour/SimpleTooltip.jsx